<template>
    <div>
          <!-- 第一部分 -->
    <div class="banner">
      <img
        src="../assets/naturemircle_banner01.png"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
    </div>  

     <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">产品特点</span>
              <span class="title_en"> Product Features</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1200px">
          <img
            src="../assets/naturemircle_banner02.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1200px; text-align: left; margin-top: 40px">
          <div class="advantage_item">
              <span>
                1. 温和而效果好
              </span>
          </div>
          <div class="advantage_item">
              <span>
                2. (1) 特别配制以满足养宠环境特定的需求；
              </span><br>
              <span>
                (2) 去污除臭系列含生物酶/酵素，在接触污垢时立即开始分解有机污垢及臭味因子
              </span>
          </div>
          <div class="advantage_item">
              <span>
                3. 易于使用
              </span>
          </div>
          <div class="advantage_item">
              <span>
                4. 美国原装进口
              </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二部分 -->
    <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">适用群体</span>
              <span class="title_en">Applicable Groups</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/naturemircle_banner03.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>

 <!-- 第三部分 -->
 <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">四大功能</span>
              <span class="title_en"> Four Functions</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 900px">
          <img
            src="../assets/naturemircle_banner04.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 20px; color: #2963a4">
              消毒</strong
            ><br />
            日常卫生级别的消毒：1比9的稀释比例，去除金黄色酿脓葡萄球菌ATCC 6538,和产气肠杆菌 ATCC 13048。直接喷晒与被消毒物体，无需冲洗，5分钟后抹干或者凉干即可。
            30秒的持续杀菌可以杀死大肠杆菌ATCC 11229，金黄色酿脓葡萄球菌 ATCC 6538。
            5分钟后病毒杀灭时间可以杀死：轮状病毒Wa，诺瓦克病毒(例如猫杯状病毒)，猪流感病毒（H1N1），呼吸道合胞体病毒ATCC VR-26
            10分钟的消毒杀菌时间可以杀死：绿浓杆菌ATCC15442, 鲍氏不动杆菌ATCC19606, 金黄色酿脓葡萄球菌 MRSA ATCC 33592, 单核细胞增多性李斯特氏菌
            ATCC10708,肺炎杆菌(NDM-1) ATCC BAA-2146
            <br><br>
            <strong style="font-size: 20px; color: #2963a4">
                除臭</strong
            ><br />
            用氧化的方式除臭，而不是掩盖气味。
            可以用来除掉如烟熏味、香烟味、霉味、陈腐的烹饪味道等等。简单的喷洒后用力搽拭，晾干后就能带来持久的除臭效果。
            注意产品必须要被喷洒到气味的源头上。
            <br><br>
            <strong style="font-size: 20px; color: #2963a4">
                清洁/祛污</strong> <br>
                含天然酵素，能彻底清除所有污渍和异味。包括食物、血渍、呕吐物、尿液、粪便、油渍、尘垢、草渍、烟垢和汗垢，
            甚至陈年污渍，顽固臭味，都能一一消灭，安全，有效。
            <br><br>
            <strong style="font-size: 20px; color: #2963a4">
                诱导趋避</strong>
          </p>
        </div>
      </div>
    </div>

    <!-- 第四部分 -->
 <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">八大功能</span>
              <span class="title_en"> Eight Functions</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/naturemircle_banner05.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1000px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 26px; color: #2963a4">
                氧橙配方系列（2 SKUs）</strong
            ><br />
            <strong style="font-size: 20px; color: #333">
                产品特点： </strong
            ><br />
            · 渗透、分解和去除嵌入的猫咪的污物和臭味<br>
            · 鲜橙香型<br>
            · 适用于地毯，地板，家具，衣物等居家环境<br>
            · 确保永久的去除污渍和异味 <br>
            <strong>使用方法：</strong><br>
               · 直接喷晒于污物或者异味源头，宠物窝垫/厕所周围。喷一下，即刻见效，异味瞬间被分解 
          </p>      
        </div>
        <div style="width: 1000px;margin-top: 40px;">
          <img
            src="../assets/naturemircle_banner06.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1000px;margin-top: 20px;">
          <img
            src="../assets/naturemircle_banner07.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1000px; text-align: left; margin-top: 60px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 26px; color: #2963a4">
                强效配方系列（3 SKUs）</strong
            ><br />
            <strong style="font-size: 20px; color: #333">
                强效清洁祛污除臭剂  </strong
            ><br />
            <strong style="font-size: 20px; color: #333">
                产品特点：  </strong
            ><br />
            · 清除顽固的宠物污物和异味 <br>
            · 去除宠物异味以防止再次弄脏<br>
               · 易干型喷剂<br>
               · 适用于地毯，地板，家具，衣物等居家环境<br>
            <strong>使用方法：</strong><br>
            · 用于祛除顽固污渍，如宠物干枯尿液，粪便等污物 <br> 
               · 方法：先清理走基本的污物后，再喷晒本产品在难于清理的污渍表面，待完全渗透后，再擦拭或清水洗掉。
          </p>      
        </div>
        <div style="width: 1000px;margin-top: 40px;">
          <img
            src="../assets/naturemircle_banner08.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 1000px;margin-top: 20px;">
          <img
            src="../assets/naturemircle_banner09.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>

    <!-- 底部栏 -->
    <foot></foot>

    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
    .w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.banner {
  width: 100%;
}
.first_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.titleBox {
  padding: 4px 0;
  //   border-bottom: 1px solid #2963a4;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  //   .title_num {
  //     font-size: 80px;
  //     font-weight: 500;
  //     color: #2963a4;
  //     margin-right: 5px;
  //   }
  .title_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    border-bottom: 5px solid #2963a4;
    .title_intro {
      font-size: 46px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .title_en {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #999;
    }
  }
}

.second_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #fff;
}

.third_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title_item {
  width: 560px;
  height: 180px;
  margin-bottom: 30px;
}

.advantage_item{
    background-color: #1262a3;
    padding: 20px 30px;
    margin-bottom: 20px;
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 1.2px;
    line-height: 1.5em;
}
</style>